<template>
  <section class="quotation-wrapper">
    <div class="row">
      <quotation-top
        :pdf="false"
        degraded
      />
    </div>
    <div class="row">
      <quotation-block>
        <quotation-vehicle degraded />
      </quotation-block>
      <quotation-block>
        <quotation-agency degraded />
      </quotation-block>
    </div>
    <div class="row">
      <quotation-block>
        <degraded-identity-form
          @validation="formValid = $event"
          @updated="updateIdentityForm"
        />
      </quotation-block>
      <quotation-block>
        <div class="content-column">
          <degraded-mode-options />
          <section class="message">
            <h6> {{ $t('components.summary.mainTitle_agency') }}</h6>
            <ul>
              <li>
                <p>{{ $t('components.summary.message') }}</p>
                <textarea v-model="form.message" />
              </li>
              <li class="message__grey">
                <h6 class="subtitle">
                  {{ $t('components.summary.type') }}*
                </h6>
                <p>{{ $t('components.summary.reservation_concern') }}</p>
                <select-list
                  svg="#icon-arrow2"
                  :simple-placeholder="this.$t('components.summary.type')"
                  :list-from-store="locationTypes"
                  :name="item.name"
                  :error="$v.form.selected"
                  :selected="form.selected"
                  @updatedSelecter="updatedSelecter"
                />
              </li>
            </ul>
          </section>
        </div>
      </quotation-block>
    </div>
    <div class="row">
      <rent-button
        class="block-wrapper"
        grey
        href="/vehicules/"
        is-anchor
      >
        {{ $t('components.degraded_mode_options.modify') }}
      </rent-button>
      <rent-button
        :loading="gettingLead"
        @buttonclicked="buttonClick"
        class="block-wrapper"
        :disabled="disabledButton"
      >
        {{ $t('components.degraded_mode_options.send') }}
      </rent-button>
    </div>
  </section>
</template>
<script>
import {
  required,
} from 'vuelidate/lib/validators';
import QuotationTop from '../QuotationTop/QuotationTop'
import QuotationBlock from '../QuotationBlock'
import QuotationVehicle from '../QuotationVehicle'
import QuotationAgency from '../QuotationAgency'
import DegradedIdentityForm from './DegradedIdentityForm'
import DegradedModeOptions from './DegradedModeOptions/DegradedModeOptions'
import RentButton from '../../shared/RentButton'
import SelectList from '../../shared/inputs/SelectList/SelectList';

export default {
  name: 'DegradedModeLayout',
  components: {
    QuotationVehicle,
    QuotationTop,
    QuotationBlock,
    QuotationAgency,
    DegradedIdentityForm,
    DegradedModeOptions,
    RentButton,
    SelectList,
  },
  data() {
    return {
      popinVisible: false,
      formValid: false,
      errorMessagesTrigger: false,
      degradedForm: null,
      form: {
        type: null,
        message: null,
      },
      item: {
        name: 'type',
      },
    };
  },
  validations: {
    form: {
      type: { required },
      message: { required },
    },
  },
  mounted() {
    this.form.message = this.$t('components.summary.placeholder');
  },
  computed: {
    locationTypes() {
      return this.$t('components.summary.list')
    },
    gettingLead() {
      return this.$store.state.leads.gettingLead
    },
    requiredFields() {
      return this.form.type && this.form.message
    },
    disabledButton() {
      if (!this.requiredFields || !this.formValid) return true

      return false
    },
  },
  methods: {
    updatedSelecter(val) {
      this.form[val.name] = val.value
      return this.$v.form[val.name] && this.$v.form[val.name].$touch()
    },
    updateIdentityForm(form) {
      this.degradedForm = form
    },
    buttonClick() {
      if (!this.requiredFields && !this.formValid) {
        this.errorMessagesTrigger = !this.errorMessagesTrigger
        return
      }
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return this.$v.form.$invalid;
      }
      return this.$store.dispatch('leads/POST_DEGRADED_LEAD', {
        message: this.form.message,
        rentalType: this.form.type,
        degradedForm: this.degradedForm,
      })
    },
  },
}
</script>
<style lang="scss" scoped>

.popin {
  background: $c-alabaster;
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 100%;
}

.content-column {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
}

textarea {
  border: 1px solid #dfdfdf;
  font-family: $f-graphie-book;
  min-height: 150px;
  width: 100%;
}

.select-list::v-deep {
  .selecter {
    svg {
      @include rotate(90deg);
    }
  }
}

.message {
  padding: 20px;

  h4 {
    color: black;
    margin-bottom: 20px;
  }

  h5 {
    color: black;
    margin-bottom: 20px;
  }
}

.subtitle {
  margin-top: 20px;
}

.quotation-wrapper {
  min-height: 100vh;
  padding: 0 0 50px;
  transition: opacity 300ms ease-out;

  &.-hide {
    opacity: 0;
    transition: none;
  }
}

.row {
  margin: auto;
  padding: 0 10px;
  width: 100%;

  @include teq-breakpoint($large) {
    max-width: calc(100% - 186px);
  }

  @include teq-breakpoint($large) {
    align-items: stretch;
    display: flex;
    justify-content: space-between;
    padding: 0;
  }

  & + & {
    margin: 20px auto 0;
  }
}

.block-wrapper,
::v-deep .block-wrapper {
  margin: 20px 0 0;

  @include teq-breakpoint($large) {
    margin: 0;
    max-width: calc(50% - 10px);
    width: 100%;
  }
}
</style>
